import { updateGlobalLoader } from "../components/backdrop/backdropSlice";
import { updateCommonData } from "../redux/commonSlice";
import { api } from "../utils/api";
import { DELIVERABLES_POST, INFLUENCER_NICHE, INFLUENCER_TYPE, PLATEFORMS } from "../utils/constant";
import { endpoints } from "../utils/endpoints";

export const getParamMasterList = () => {
    return (dispatch, getState) => {
        dispatch(updateGlobalLoader(true));
        const { user } = getState().app;
        api.getApiCall(
            endpoints.paramMaster,
            ``,
            (respData) => {
                dispatch(updateGlobalLoader(false));
                let data = respData.data.result;
                dispatch(
                    updateCommonData({
                        paramMasterList: respData.data.result,
                        plateforms: JSON.parse(data?.find((v) => v.parameterkey === PLATEFORMS)?.value),
                        deliverablesPlatform: JSON.parse(data?.find((v) => v.parameterkey === DELIVERABLES_POST)?.value),
                        niches: JSON.parse(data?.find((v) => v.parameterkey === INFLUENCER_NICHE)?.value)?.map((v) => v.option),
                        influencerType: JSON.parse(data?.find((v) => v.parameterkey === INFLUENCER_TYPE)?.value),
                        userDetails: JSON.parse(user || "{}")
                    })
                );

            },
            (error) => {
                dispatch(updateGlobalLoader(false));
                let { data } = error;
                console.log(data?.message);
            }
        );
    };
};
